import { render, staticRenderFns } from "./FrontierTourDetail.vue?vue&type=template&id=103d8a54&scoped=true"
import script from "./FrontierTourDetail.vue?vue&type=script&lang=js"
export * from "./FrontierTourDetail.vue?vue&type=script&lang=js"
import style0 from "./FrontierTourDetail.vue?vue&type=style&index=0&id=103d8a54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103d8a54",
  null
  
)

export default component.exports